<template>
  <v-btn fab small class="dial-button" v-bind="$attrs" v-on="$listeners">
    <transition name="slide">
      <v-sheet
        v-if="showLabel"
        elevation="4"
        rounded
        class="py-2 px-4 dial-button__label"
      >
        {{ label }}
      </v-sheet>
    </transition>
    <v-icon small class="dial-button__icon">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'mdiCircleOutline',
    },
    label: {
      type: String,
      default: '',
    },
  },
  mounted() {
    // Hacky way to trigger transition on opening menu
    this.showLabel = !!this.label;
  },
  data() {
    return {
      showLabel: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.dial-button__label {
  position: absolute;
  text-align: center;
  min-width: 80px;
  right: 50px;
  transition: color 0.2s ease;

  .v-btn:hover & {
    color: var(--v-primary-base);
  }
}

.v-btn:hover .dial-button__icon {
  color: var(--v-primary-base);
}

.slide-enter,
.slide-leave-to {
  transform: translateX(50px);
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.25s ease;
}
</style>
